module.exports = "../../static/img/carotDown.00f3e75.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/carotDown.png
// module id = 1374
// module chunks = 0